import { configureStore } from '@reduxjs/toolkit';
import { setUnauthorizedHandler } from '@srichaitra/api';
import { authReducer, sessionExpired } from './authSlice';
import { notificationReducer } from './notificationSlice';
import { dashboardReducer } from './dashboardSlice';
import { trendsReducer } from './trendsSlice';

/**
 * The application's single Redux store.
 *
 * Created by a function rather than at module scope so tests can build a fresh
 * one per case — a store shared between tests carries state across them and
 * produces failures that depend on execution order.
 *
 * The store also closes the loop with the API layer: the interceptor cannot
 * import the store (the store imports the API, so that would be a cycle), so it
 * accepts a callback instead. Registering it here means a session that cannot
 * be refreshed ends up dispatching sessionExpired, and every subscribed
 * component reacts to it the same way it reacts to a deliberate sign-out.
 */
export function createAppStore(preloadedState) {
  const store = configureStore({
    reducer: {
      auth: authReducer,
      notifications: notificationReducer,
      dashboard: dashboardReducer,
      trends: trendsReducer
    },
    preloadedState
  });

  setUnauthorizedHandler(() => {
    store.dispatch(sessionExpired());
  });

  return store;
}
